export class CategoryService {
  /**
   * @var {String}
   */
  id;

  /**
   * @var {String}
   */
  icon;

  /**
   * @var {String}
   */
  name;

  /**
   * @var {String}
   */
  color;

  /**
   * @var {String}
   */
  custom_color;

  /**
   * @var {Boolean}
   */
  is_connected;

  active;

  is_live;

  is_stored;

  original_id;

  constructor(model = {}) {
    this.id = model.id;
    this.icon = model.icon || 'serviceicon-default';
    this.custom_color = model.custom_color;
    this.name = model.name;
    this.color = model.color;
    this.is_connected = model.is_connected;
    this.active = model.active;
    this.is_stored = model.is_stored === undefined ? true : model.is_stored;
    this.is_live = model.is_live || false;
    this.original_id = model.original_id || model.id;
  }

  /**
   * @returns {string}
   */
  getIcon() {
    return this.icon.startsWith('serviceicon') ? this.icon : `serviceicon-${this.icon}`;
  }

  getColor() {
    return this.custom_color || this.color;
  }
}
